export default "/template/resource//static/media/img_wutuandui@2x.cc5d0d74.png";